import type { apiClient } from '~/shared/api/data-ingestion-api'
import type { ClusterEventProps } from '../../model'

export function transformCluster(event: apiClient.AuditEvent): ClusterEventProps {
  return {
    type: 'cluster',
    timestamp: event.timestamp,
    user: event.user,
    userRole: event.user ? 'person' : 'opti',
    step: 'clustering',
    eventType: event.event_type,
    title: 'Clustered',
    subjectPersonCount: event.subject_person_count ?? null,
    subjectPersons:
      event.subject_persons?.map((p) => ({
        firstName: p.first_name ?? null,
        lastName: p.last_name ?? null,
        description: p.description ?? null,
      })) ?? null,
  }
}

export function getClusterSearchableText(props: ClusterEventProps): string {
  const parts = [props.title]
  if (props.subjectPersons) {
    for (const p of props.subjectPersons) {
      const name = [p.firstName, p.lastName].filter(Boolean).join(' ')
      if (name) parts.push(name)
      if (p.description) parts.push(p.description)
    }
  }
  return parts.join(' ')
}
